module.exports = __webpack_public_path__ + "img/1588721756.80230fc1.jpg";